import type { ThemeConfig } from 'antd';

export const THEME_TOKEN: ThemeConfig['token'] = {
  fontFamily: 'var(--font-primary)',
  colorBgLayout: 'var(--color-gray-1)',
  colorText: 'var(--color-gray-9)',
  colorPrimary: '#5c4fed', // primary
  colorError: '#ff6768', // red-6
};

export const THEME_COMPONENTS: ThemeConfig['components'] = {
  Layout: {
    headerBg: 'var(--color-gray-9)',
    headerColor: 'var(--color-gray-1)',
    siderBg: 'var(--color-gray-2)',
  },
  Dropdown: {
    paddingContentHorizontal: 0,
    colorTextDisabled: 'var(--color-gray-7)',
  },
  Form: {
    itemMarginBottom: 16,
  },
  Button: {
    borderRadius: 8,
    fontSizeLG: 14,
    colorLink: 'var(--color-primary)',
    colorLinkHover: 'var(--color-violet-5)',
    colorLinkActive: 'var(--color-primary)',
  },
  Input: {
    fontSizeLG: 14,
    colorTextPlaceholder: 'var(--color-gray-7)',
    borderRadius: 8,
  },
  Select: {
    controlHeightSM: 22,
    optionSelectedBg: 'var(--color-gray-14)',
    optionSelectedFontWeight: 500,
    borderRadius: 8,
    borderRadiusSM: 6,
  },
  Segmented: {
    itemActiveBg: 'var(--color-gray-14)',
    itemColor: 'var(--color-gray-8)',
    itemHoverBg: 'var(--color-gray-1)',
    itemHoverColor: 'var(--color-gray-9)',
    itemSelectedBg: 'var(--color-gray-14)',
    itemSelectedColor: 'var(--color-gray-9)',
    trackBg: 'var(--color-gray-1)',
    trackPadding: 1,
  },
  Tabs: {
    horizontalItemPaddingLG: '12px 0 14px',
    itemActiveColor: 'var(--color-gray-9)',
    itemColor: 'rgba(38, 38, 38, .7)',
    itemHoverColor: 'var(--color-gray-9)',
    itemSelectedColor: 'var(--color-gray-9)',
  },
  Collapse: {
    headerBg: 'var(--color-gray-3)',
    headerPadding: '8px 16px 8px 12px',
    contentPadding: 0,
  },
  Table: {
    cellPaddingBlock: 12,
    headerBg: 'var(--color-gray-3)',
    headerColor: 'var(--color-gray-9)',
    headerSplitColor: 'transparent',
    headerBorderRadius: 0,
    rowHoverBg: 'var(--color-gray-14)',
    rowExpandedBg: 'transparent',
    borderColor: 'var(--color-gray-5)',
    rowSelectedBg: 'var(--color-gray-1)',
    rowSelectedHoverBg: 'var(--color-gray-14)',
  },
  Radio: {
    borderRadius: 8,
    buttonCheckedBg: 'var(--color-gray-14)',
    buttonColor: 'var(--color-gray-9)',
    colorTextDisabled: 'var(--color-gray-6)',
    colorBgContainerDisabled: 'var(--color-gray-2)',
    buttonCheckedBgDisabled: 'var(--color-gray-2)',
  },
  Checkbox: {
    colorPrimary: 'var(--color-violet-5)',
  },
  DatePicker: {
    borderRadius: 8,
  },
  Modal: {
    colorBgMask: 'rgba(38, 38, 38, .8)',
  },
  Alert: {
    defaultPadding: '8px 16px',
    withDescriptionPadding: '8px 16px',
    withDescriptionIconSize: 14,
  },
  Slider: {
    railSize: 3,
    railBg: 'var(--color-gray-5)',
    railHoverBg: 'var(--color-gray-5)',
    trackBg: 'var(--color-primary)',
    trackHoverBg: 'var(--color-primary)',
    handleColor: 'var(--color-gray-1)',
    handleActiveColor: 'var(--color-primary)',
    handleColorDisabled: 'var(--color-gray-1)',
    handleSize: 12,
    handleSizeHover: 14,
    handleLineWidth: 1,
    handleLineWidthHover: 1,
  },
  Steps: {
    colorPrimary: 'var(--color-violet-5)',
    colorText: 'var(--color-gray-9)',
    fontSize: 12,
    lineHeight: 1.666667,
  },
  Divider: {
    orientationMargin: 0,
  },
};
